import { createPinia } from 'pinia';
import PrimeVue from 'primevue/config';
import { initializeApp } from '@/apps/admin/main';
import { initializePublicApp } from '@/apps/public/main';
import i18n, { jobBoardI18n } from './i18n';

let app = null;
if (import.meta.env.MODE === 'public') {
   app = initializePublicApp();
} else {
   app = initializeApp();
}

// use $t - uses user locale
app.use(i18n);
// use $tb - uses board active language
app.config.globalProperties.$tb = jobBoardI18n.global.t;

app.use(PrimeVue);
app.use(createPinia());
app.mount('#app');
